// extracted by mini-css-extract-plugin
export default {"mobileHeight":"screen and (max-height: 824px)","goalButton":"Goal_goalButton__mIFxI","goalContent":"Goal_goalContent__mi2AU","label":"Goal_label__iKQaG","icon":"Goal_icon__joHSv"};